import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Input } from 'components/fields'
import { Form } from 'components/layout'
import { FormButton, Module } from 'components/misc'
import { form } from 'helpers/decorators'
import { apiPasswords } from 'helpers/decorators/api'
import { validate } from 'models/forgotten-password'

@form({
  form: 'forgottenPasswordForm',
  disableHook: true,
  validate
})
@apiPasswords()
class ForgottenPasswordForm extends Component {
  static propTypes = {
    pristine: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    resetRequest: PropTypes.func.isRequired,
    submitting: PropTypes.bool
  }

  static defaultProps = {
    loading: false
  }

  render() {
    const { handleSubmit, resetRequest, pristine, submitting } = this.props

    return (
      <Module>
        <Form onSubmit={handleSubmit(resetRequest)}>
          <h2 className="alpha nowrap">
            <FormattedMessage
              id="moduleTitle.forgotten_password"
              defaultMessage="Forgotten Password"
            />
          </h2>
          <Input
            name="email"
            label="Email address"
            intlKey="label.email_address"
          />
          <FormButton pristine={pristine} simple fluid isLoading={submitting}>
            <FormattedMessage id="button.send" defaultMessage="Send" />
          </FormButton>
        </Form>
      </Module>
    )
  }
}

export default ForgottenPasswordForm
